// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1NKRv","inner":"Footer_inner__18wBf","nextIcon":"Footer_nextIcon__3C81q","innerLeft":"Footer_innerLeft__vE9Hy"};